(() => {
  const LEAFLET_JS = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
  const LEAFLET_CSS = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
  const TILE_URL = 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png';
  const ATTRIBUTION = '&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/">CARTO</a>';
  const DEFAULT_MARKER_ICON = 'https://cdn.shopify.com/s/files/1/0918/0181/3319/files/DD.png?v=1764001386';

  function ensureLeafletAssets() {
    if (window.__studdyLeafletPromise) {
      return window.__studdyLeafletPromise;
    }

    window.__studdyLeafletPromise = new Promise((resolve, reject) => {
      if (window.L) {
        resolve(window.L);
        return;
      }

      if (!document.getElementById('leaflet-css')) {
        const link = document.createElement('link');
        link.id = 'leaflet-css';
        link.rel = 'stylesheet';
        link.href = LEAFLET_CSS;
        document.head.appendChild(link);
      }

      const script = document.createElement('script');
      script.src = LEAFLET_JS;
      script.onload = () => resolve(window.L);
      script.onerror = reject;
      document.head.appendChild(script);
    });

    return window.__studdyLeafletPromise;
  }

  function normalizeCoordinate(value) {
    if (value == null) {
      return Number.NaN;
    }

    if (typeof value === 'number') {
      return value;
    }

    if (typeof value === 'string') {
      const normalized = value.trim().replace(',', '.');
      return parseFloat(normalized);
    }

    return Number.NaN;
  }

  function formatMarkerContent(rawLabel) {
    if (!rawLabel || typeof rawLabel !== 'string') {
      return '';
    }

    const lines = rawLabel
      .split(/\n+/)
      .map((line) => line.trim())
      .filter(Boolean);

    if (!lines.length) {
      return '';
    }

    const [firstLine, ...rest] = lines;
    const formattedFirstLine = `<strong>${firstLine}</strong>`;
    if (!rest.length) {
      return formattedFirstLine;
    }

    return `${formattedFirstLine}<br>${rest.join('<br>')}`;
  }

  function initMap(el) {
    if (el.dataset.mapInitialized === 'true') {
      return;
    }

    const lat = normalizeCoordinate(el.dataset.lat);
    const lng = normalizeCoordinate(el.dataset.lng);
    const zoom = parseInt(el.dataset.zoom || '15', 10);
    const markerLabel = el.dataset.marker || '';
    const markerIcon = el.dataset.markerIcon || DEFAULT_MARKER_ICON;

    if (Number.isNaN(lat) || Number.isNaN(lng)) {
      console.warn('Invalid coordinates for map element', el);
      return;
    }

    ensureLeafletAssets()
      .then((L) => {
        const map = L.map(el, {
          zoomControl: false,
          attributionControl: false,
          scrollWheelZoom: false,
          dragging: !window.matchMedia('(max-width: 749px)').matches
        }).setView([lat, lng], zoom);

        L.tileLayer(TILE_URL, {
          attribution: ATTRIBUTION,
          maxZoom: 19
        }).addTo(map);

        const icon = L.icon({
          iconUrl: markerIcon,
          iconSize: [32, 32],
          iconAnchor: [16, 28],
          popupAnchor: [0, -24],
          className: 'studdy-map__marker'
        });

        const marker = L.marker([lat, lng], { icon }).addTo(map);
        if (markerLabel) {
          const popupContent = formatMarkerContent(markerLabel) || markerLabel;
          marker.bindPopup(popupContent);
        }

        el.dataset.mapInitialized = 'true';
      })
      .catch((error) => {
        console.error('Failed loading Leaflet', error);
      });
  }

  function initAll(root = document) {
    root.querySelectorAll('[data-studdy-map]').forEach(initMap);
  }

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();

